import React, { useRef } from 'react';
import {
  Box,
  Button,
  Center,
  CloseButton,
  Grid,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useColorModeValue,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react';
import { ImInfo } from 'react-icons/im';

import { NoPhotosIcon, NoScansIcon, PDFOnlyIcon } from 'clipsal-cortex-icons/src/custom-icons';

export function UploadBillInfoPopover() {
  const textColor = useColorModeValue('black', 'white');
  const ref = useRef<HTMLElement | null>(null);
  const { onOpen, onClose, isOpen } = useDisclosure();
  useOutsideClick({
    ref: ref as React.RefObject<HTMLElement>,
    handler: () => onClose(),
  });

  return (
    <Popover isOpen={isOpen} trigger={'hover'}>
      <>
        <PopoverTrigger>
          <Button
            data-testid="upload-bill-info-popover-trigger"
            variant={'unstyled'}
            onClick={(e) => {
              // Prevent default functionality and bubbling where clicking anywhere inside dropzone triggers
              // file upload window
              e.preventDefault();
              e.stopPropagation();
              onOpen();
            }}
          >
            <Box as={ImInfo} color={'customBlue.500'} size="18px" />
          </Button>
        </PopoverTrigger>

        <PopoverContent
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          ref={ref}
          data-testid="upload-bill-info-popover"
          p={2}
          rounded={20}
          w="inherit"
          zIndex={4}
        >
          <PopoverArrow />
          <CloseButton
            color={textColor}
            data-testid="about-bill-upload-popover-close-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
            }}
            position={'absolute'}
            right={3}
          />

          <PopoverBody>
            <Text maxW={'280px'} mb={2} color={textColor}>
              You can provide multiple bills, containing up to 24 months of recent energy usage. Please make sure you
              upload the original electricity bill in e-PDF format.
            </Text>
            <Grid gridTemplateColumns={'repeat(3, 1fr)'}>
              <Center flexDirection={'column'} p={1}>
                <PDFOnlyIcon color={textColor} />
                <Text color={textColor} fontSize="xs">
                  PDF only
                </Text>
              </Center>
              <Center flexDirection={'column'} p={1}>
                <NoPhotosIcon color={textColor} />
                <Text color={textColor} fontSize="xs">
                  No photos
                </Text>
              </Center>
              <Center flexDirection={'column'} p={1}>
                <NoScansIcon color={textColor} />
                <Text color={textColor} fontSize="xs">
                  No scans
                </Text>
              </Center>
            </Grid>
          </PopoverBody>
        </PopoverContent>
      </>
    </Popover>
  );
}
